import type { ReactNode } from 'react'
import {
  Tooltip as BaseTooltip,
  TooltipContent,
  TooltipTrigger,
} from './ui/tooltip'

interface Props {
  children: ReactNode
  content: ReactNode
  asChild?: boolean
  sideOffset?: number
}

export function Tooltip({
  children,
  content,
  asChild = true,
  sideOffset = 4,
}: Props) {
  return (
    <BaseTooltip>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>

      <TooltipContent sideOffset={sideOffset}>{content}</TooltipContent>
    </BaseTooltip>
  )
}
